import loadable from "@loadable/component";
import React from "react";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import { tw } from "@careinfo/tailwind";
const StatusListComponent = loadable(
  () => import("../../components/Status/StatusList")
);

const StatusList = () => {
  const { mutateAsync: patchStatus, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["status"],
    navigateURL: "",
  });
  const handleIsEnableEmail = async (value: boolean, id: any) => {
    const payload = {
      is_enable_email: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSMS = async (value: boolean, id: any) => {
    const payload = {
      is_enable_sms: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleCal_Cod = async (value: boolean, id: any) => {
    const payload = {
      calc_collected_cod: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnablePartial = async (value: boolean, id: any) => {
    const payload = {
      is_partial_status: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsCreateInvoice = async (value: boolean, id: any) => {
    const payload = {
      is_create_invoice: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };

  const handleIsRTV = async (value: boolean, id: any) => {
    const payload = {
      is_allow_to_create_rtv: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };

  const handleIsFinalState = async (value: any, id: any) => {
    const payload = {
      is_final_state: value,
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Status</span>
      </div>
      <StatusListComponent
        handleIsActive={handleIsActive}
        handleIsRTV={handleIsRTV}
        handleIsFinalState={handleIsFinalState}
        handleIsEnableEmail={handleIsEnableEmail}
        handleIsEnableSMS={handleIsEnableSMS}
        handleIsEnablePartial={handleIsEnablePartial}
        handleIsCreateInvoice={handleIsCreateInvoice}
        handleCal_Cod={handleCal_Cod}
      />
    </>
  );
};

export default StatusList;
